<!-- Layout matching mockup Dashboard.tsx -->
<div class="flex">
  <!-- Navigation Sidebar (Left) -->
   <div style="position: sticky; top: 0;" *ngIf="!isHorizontal">
  <app-sidebar *ngIf="!isHorizontal"></app-sidebar>
    </div>
  
  <!-- Main Content Area -->
  <div class="flex-1 flex flex-col relative bg-muted">
    <!-- Header (Top) -->
    <app-navbar (onMenuClick)="toggleSidebar()"></app-navbar>
    
    <!-- Content Area -->
    <main class="">
      <router-outlet></router-outlet>
    </main>
  </div>
  
  <!-- Horizontal Menu (if enabled) -->
  <div *ngIf="isHorizontal" class="w-full">
    <app-sidebar></app-sidebar>
  </div>
</div>

